import { makeAutoObservable } from "mobx";
import { isMobile } from "../utils/device/isMobile";
import { SidebarStepEnum } from "../modules/controls-sidebar/helpers/getStepsOrderByClipId";

class SidebarStoreInstance {
  activeItemKey: string | null = isMobile() ? null : "stock";
  activeControlItemKey: SidebarStepEnum | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setActiveItemKey(id: string | null) {
    this.activeItemKey = id;
  }
  setActiveControlItemKey(id: SidebarStepEnum | null) {
    this.activeControlItemKey = id;
  }

  reset() {
    this.activeItemKey = null;
    this.activeControlItemKey = null;
  }
}

const SidebarStore = new SidebarStoreInstance();

export { SidebarStore };
